<div class="page">
  <div class="content page-header">
    <h1 data-qa="page-title">Netzbetreiberliste</h1>
    <div class="page-actions">
      @if (authenticationService.isAdmin(authenticationService.user)) {
        <button data-qa="erstelle-netzbetreiber-button"
                matButton="filled" (click)="openNewDialog()"
        >
          <mat-icon>add</mat-icon>
          Neuer Netzbetreiber
        </button>
      }

      @if (authenticationService.isUenb(authenticationService.user) || authenticationService.isVnb(authenticationService.user)) {
        <button data-qa="export-csv-button"
                matButton="filled" (click)="exportListAsCSV()"
        >
          <mat-icon>save_alt</mat-icon>
          Export Netzbetreiber
        </button>
      }
    </div>
  </div>
  <div class="content page-content">
    <ufla-netzbetreiberliste data-qa="ufla-netzbetreiber-table">
    </ufla-netzbetreiberliste>
  </div>
</div>
